// extracted by mini-css-extract-plugin
export default {"recaptchaContainer":"ReCAPTCHA_recaptchaContainer__2I8qE"};